import { appConfigs, type LocalApp } from 'ApplicationContext.tsx';
import { APP, GENIE } from './Permissions.ts';

export type AccessGuard = (options: { groups: string[]; app: LocalApp; isAdmin: boolean }) => boolean;

export const hasGroups = (group: string): AccessGuard => {
  return ({ groups, isAdmin }: { groups: string[]; isAdmin: boolean }): boolean => groups.includes(group) || isAdmin;
};

export const genieUser = (groups: string[]): boolean => groups.includes(GENIE);

export const appUser = hasGroups(APP);

export const hasAppAccess = (app: LocalApp): AccessGuard => {
  return ({ app: currentApp, groups, isAdmin }: { app: LocalApp; groups: string[]; isAdmin: boolean }): boolean => {
    if (app !== currentApp) {
      return false;
    }

    const appGroups = appConfigs[app].cognitoGroups;
    return groups.some((group) => appGroups.includes(group)) || isAdmin;
  };
};

export const hasAnyAccess = (...guards: AccessGuard[]) => {
  return (options: { groups: string[]; app: LocalApp; isAdmin: boolean }): boolean =>
    guards.some((guard) => guard(options));
};

export const pmsUser = hasAppAccess('pms');
export const portfolioLabUser = hasAppAccess('portfolioLab');
export const hasAccessToAnyApp = (options: { groups: string[]; app: LocalApp; isAdmin: boolean }): boolean => {
  return pmsUser(options) || portfolioLabUser(options) || options.isAdmin;
};
